export default "__VITE_ASSET__de2b2518__"